import { render, staticRenderFns } from "./boxCitySelectCsdsz.vue?vue&type=template&id=6ce4a3bb&scoped=true"
import script from "./boxCitySelectCsdsz.vue?vue&type=script&lang=js"
export * from "./boxCitySelectCsdsz.vue?vue&type=script&lang=js"
import style0 from "./boxCitySelectCsdsz.vue?vue&type=style&index=0&id=6ce4a3bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce4a3bb",
  null
  
)

export default component.exports